<template>
    <div>
        <div class="container-fluid">
            <div class="row mx-auto">
                <div class="col-md-12">
                    <div class=" p-4 my-5">
                        <div class="large-12  medium-12 small-12 filezone">
                            <input type="file" id="files" ref="files" multiple @change="handleFilesUpload()"/>
                            <p class="mt-2 text-center">
                                <i class="fa fa-cloud-upload-alt text-primary fa-5x d-block"></i>
                                فایل مورد نظر را اینجا بکشید ورها کنید.<br>یا برای آپلود فایل خود اینجا کلیک کنید.
                                <br>
                                اندازه عکس باید حداقل <label class="text-blue-500 font-black">۶۰۰ در ۶۰۰</label>
                                پیکسل باشد.
                            </p>
                        </div>
                        <div>
                            <div class="row my-3">
                                <div v-for="(file, key) in files"
                                     :key="file.name"
                                     class="position-relative col-md-4"
                                     :data-imgName="file.name"
                                >
                                    <img :src="file"
                                         class="img-fluid "
                                         :data-id="'files.'+key" :ref="'preview'+parseInt(key)"
                                         id="imagess"
                                         :style="{opacity:(loadingValue[key] > 25 ? loadingValue[key] /100 : '0.3')}"
                                         :alt="key">
                                    <i @click="removeFile(key)"
                                       class="fa fa-trash-alt position-absolute border-secondary p-2 text-white bg-danger"
                                       style="cursor: pointer ; font-size: 20px;left:0;border-radius: 50%;"
                                    >
                                    </i>
                                    <v-progress-linear v-if="loadingValue[key]<100"
                                                       :color="loadingValue[key]=== 100 ? 'green':'red' " :key="key"
                                                       :value="loadingValue[key]"
                                    >
                                    </v-progress-linear>
                                </div>
                            </div>
                        </div>
                        <div v-if="files.length > 0">
                            <v-btn :loading="!newImage" class="btn-upload" @click="submitFiles(0)">
                                <span class="fa fa-upload mr-2"></span>
                                ثبت
                            </v-btn>
                        </div>
                        <v-container v-if="Object.keys(img).length>0 && forNew" fluid>
                            <v-row class="my-3 mx-auto">
                                <v-col
                                        v-for="item in img"
                                        class="d-flex child-flex p-1 bg-white mx-2 my-1 rounded-circle shadow-lg position-relative"
                                        cols="12"
                                        :key="item.md5"
                                        md="2"
                                >
                                    <v-img
                                            :src="item.link"
                                            aspect-ratio="1"
                                            class="rounded-circle"

                                    >
                                        <v-icon
                                                small
                                                color="danger"
                                                @click="removeFromGallery(item.md5)"
                                                class="float-right p-1 text-white bg-danger m-5 rounded-circle position-absolute"
                                                style="cursor: pointer ; font-size: 20px;top:-8px;right:-18%;z-index: 22222"
                                        >
                                            mdi-trash-can-outline
                                        </v-icon>
                                    </v-img>
                                </v-col>
                            </v-row>
                        </v-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PicSelector from "../uploadCenter/picSelector";
import TitleRibbon from "./titleRibbon";
import {Bus} from "../../../main";

export default {
    name: "imageUploader",
    components: {TitleRibbon, PicSelector},
    props: {
        editImg: {},
        forNew: true,
    },
    data: () => ({
        files: [],
        img: [],
        erroredPic: 0,
        successPic: 0,
        refresh: true,
        newImage: true,
        loadingValue: [],

    }),
    methods: {
        getImagePreviews() {
            for (let i = 0; i < this.files.length; i++) {
                if (/\.(jpe?g|png|gif)$/i.test(this.files[i].name)) {
                    let reader = new FileReader();
                    reader.addEventListener("load", function () {
                        this.$refs['preview' + parseInt(i)][0].src = reader.result;
                    }.bind(this), false);
                    reader.readAsDataURL(this.files[i]);
                } else {
                    this.$nextTick(function () {
                        this.$refs['preview' + parseInt(i)][0].src = '/img/generic.png';
                    });
                }
            }
        },
        handleFilesUpload() {
            const uploadedFiles = this.$refs.files.files;

            for (var i = 0; i < uploadedFiles.length; i++) {
                this.files.push(uploadedFiles[i]);
            }
            this.getImagePreviews();
        },
        addFiles() {
            this.$refs.files
        },
        removeFile(key) {
            this.files.splice(key, 1);
            this.getImagePreviews();
        },
        getImages() {
            $.ajax({
                url: `${url}/user/upload`,
                fn: this.getImages,
                headers: {
                    ACCEPT: "application/json",
                    Authorization: Token
                },
                type: "GET",
                success: (data) => {
                    this.img = data.data;
                }
            })
        },
        removeFromGallery: function (key) {
            const vm = this;
            $.ajax({
                url: `${url}/user/upload/${key}`,
                method: "DELETE",
                fn: this.removeFromGallery,
                params: [key],
                headers: {
                    ACCEPT: 'application/json',
                    Authorization: Token
                },
                msg: true,
                success: function (res) {
                    vm.img = [];
                    setTimeout(() => {
                        vm.getImages();
                    }, 4000)
                }
            })
        },
        submitFiles(item = 0) {
            this.newImage = false
            let formData = new FormData();
            formData.append('file', this.files[item]);
            $.ajax({
                url: `${url}/user/upload`,
                fn: this.submitFiles,
                params: [item],
                type: 'POST',
                data: formData,
                headers: {
                    "Authorization": Token,
                    "ACCEPT": "application/json"
                },
                xhr: () => {
                    let xhr = new window.XMLHttpRequest();
                    xhr.upload.addEventListener("progress", (evt) => {
                        if (evt.lengthComputable) {
                            this.loadingValue[item] = (evt.loaded / evt.total) * 100;
                            this.$forceUpdate()
                        }
                    }, false);
                    return xhr;
                },
                contentType: false,
                processData: false,
                msg: this.files.length <= item + 1 && this.erroredPic === 0,
                reload: this,
                success: ((res) => {
                    this.img = res.data;
                    Bus.$emit('selectedImage', res.data);

                })
            }).always((data) => {
                try {
                    document.querySelectorAll('#imagess')[item].classList.add(data.status === true ? " " : "border-danger");
                    this.erroredPic += 1;
                } catch (e) {
                    this.getImages();
                }

                item++;
                data.status === true ? this.successPic++ : this.erroredPic++;

                if (this.files.length > item)
                    this.submitFiles(item);
                else {
                    this.newImage = true;
                    if (this.erroredPic <= 0) {
                        setTimeout(() => {
                            this.getImages();
                        }, 7000)
                    } else {
                        this.$nextTick(function () {
                            this.$modal.error('خطا!', 'لظفا عکس های مشخص شده با کادر قرمز را حذف و با عکس درست جایگزین کنید و دوباره ثبت کنید.')
                        })
                        this.erroredPic = 0
                    }
                }

            })
        },
    },
    watch: {
        editImg: {
            handler(value) {
                console.log(value)
                if (value.length > 0) {
                    this.img = value;
                }
            },
            deep: true
        },
        files(value) {
            for (let i = 0; i < value.length; i++) {
                this.loadingValue.push(0);
            }
            ;
        }
    },
    mounted() {
        if (this.editImg.length > 0) {
            this.img = this.editImg;
        }
    }
}
</script>

<style scoped>

</style>